import { TouchButtons } from '../../input/TouchButtons';
import { TouchPad } from '../../input/TouchPad';

export class ControlsGuide extends Phaser.GameObjects.Container {
  constructor(scene, isTouch) {
    super(scene);
    scene.add.existing(this);
    this.isTouch = isTouch;
    if (isTouch) {
      this.createTouchDemo();
    } else this.createKeyboardDemo();
  }

  get state() {
    return this._state;
  }

  setState(demo) {
    if (this.isTouch) this.setTouchDemo(demo);
    else this.setKeyboardDemo(demo);
  }

  // =============================================================================================
  // TOUCH
  // =============================================================================================
  createTouchDemo() {
    this.touchPad = new TouchPad(this.scene);
    this.touchPad.scale = 0.7;
    this.touchPad.x = this.touchPad.displayWidth * 0.5;
    this.touchPad.y = this.touchPad.displayHeight * 0.5;
    this.btnJump = this.scene.add.image(250, 125, 'graphics', 'btn_jump').setScale(0.85);
    this.btnAttack = this.scene.add.image(375, 125, 'graphics', 'btn_attack').setScale(0.85);
    this.btnSpecial = this.scene.add.image(500, 125, 'graphics', 'btn_special').setScale(0.85);
    this.add([this.touchPad, this.btnJump, this.btnAttack, this.btnSpecial]);
  }
  setTouchDemo(demo) {
    this.clearTouchDemo();
    switch (demo) {
      case 'demoWalk':
        this.touchPad.setDemoDirection(1, 0);
        break;
      case 'demoJump':
        this.btnJump.setFrame('btn_jump_over');
        break;
      case 'demoAttack':
      case 'demoPickup':
        this.btnAttack.setFrame('btn_attack_over');
        break;
      case 'demoSpecial':
        this.btnSpecial.setFrame('btn_special_over');
        break;
    }
    this._state = demo;
  }

  clearTouchDemo() {
    this.touchPad.setDemoDirection(0, 0);
    this.btnJump.setFrame('btn_jump');
    this.btnAttack.setFrame('btn_attack');
    this.btnSpecial.setFrame('btn_special');
  }

  // =============================================================================================
  // KEYBOARD
  // =============================================================================================
  createKeyboardDemo() {
    this.keyLeft = this.scene.add.image(48, 106, 'locale_text', 'key_left');
    this.keyRight = this.scene.add.image(228, 106, 'locale_text', 'key_right');
    this.keyUp = this.scene.add.image(113, 32, 'locale_text', 'key_up');
    this.keyDown = this.scene.add.image(138, 106, 'locale_text', 'key_down');
    this.keyAttack = this.scene.add.image(438, 106, 'locale_text', 'key_attack');
    this.keyJump = this.scene.add.image(348, 106, 'locale_text', 'key_jump');
    this.keySpecial = this.scene.add.image(528, 106, 'locale_text', 'key_special');
    this.add([
      this.keyLeft,
      this.keyRight,
      this.keyUp,
      this.keyDown,
      this.keyAttack,
      this.keyJump,
      this.keySpecial,
    ]);
  }

  setKeyboardDemo(demo) {
    this.clearKeyboardDemo();
    switch (demo) {
      case 'demoWalk':
        this.keyRight.setFrame('key_right_over');
        break;
      case 'demoJump':
        this.keyJump.setFrame('key_jump_over');
        break;
      case 'demoAttack':
      case 'demoPickup':
        this.keyAttack.setFrame('key_attack_over');
        break;
      case 'demoSpecial':
        this.keySpecial.setFrame('key_special_over');
        break;
    }
    this._state = demo;
  }

  clearKeyboardDemo() {
    this.keyLeft.setFrame('key_left');
    this.keyRight.setFrame('key_right');
    this.keyUp.setFrame('key_up');
    this.keyDown.setFrame('key_down');
    this.keyAttack.setFrame('key_attack');
    this.keyJump.setFrame('key_jump');
    this.keySpecial.setFrame('key_special');
  }
}
